// extracted by mini-css-extract-plugin
export default {"section":"SubSection_section__CW9Iy","sectionTitle":"SubSection_sectionTitle__WbmoS","description":"SubSection_description__huqre"};